<template>
  <div v-if="emailData">
    <p class="font-bold text-xl text-center my-2">{{ emailData.subject }}</p>
    <div v-html="emailData.html_content"></div>
  </div>
  <div v-else-if="error">
    <p class="text-red font-bold w-fit m-4 mx-auto text-2xl">Une erreur est survenue</p>
  </div>
  <div v-else>
    <p>Chargement de l'email...</p>
  </div>
</template>

<script>
export default {
  data() {
    return {
      emailData: null,
      error: false,
    };
  },
  async mounted() {
    try {
      const token = this.$route.query.token;
      const { data } = await this.$api.previewEmail(token)
      this.emailData = data;
      this.error = false
    } catch (error) {
      console.error("Erreur lors du chargement de l'email", error);
      this.error = true
    }
  }
};
</script>
